import React, { useState } from "react";
import { API_BASE } from "@/lib/api";
import { FileDown } from "lucide-react";
import { toast } from "sonner";

export default function ExportExcelButton({ path, filename, label = "Export Excel", testid = "export-excel-btn" }) {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const token = localStorage.getItem("cpl_token");
      const res = await fetch(`${API_BASE}${path}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = filename; a.click();
      window.URL.revokeObjectURL(url);
      toast.success("Export downloaded");
    } catch (err) {
      toast.error("Export failed: " + (err?.message || "unknown"));
    } finally { setBusy(false); }
  };

  return (
    <button data-testid={testid} onClick={download} disabled={busy}
      className="inline-flex items-center gap-2 px-4 py-2 bg-[#FFFFFF] border border-[#E5E7EB] hover:bg-[#F8FAFC] rounded-md text-sm disabled:opacity-50">
      <FileDown size={14} /> {busy ? "Exporting..." : label}
    </button>
  );
}
